var _style, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglepubsub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.1 362.4",
    style: {
      enableBackground: "new 0 0 406.1 362.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.googlepubsub0{fill:url(#Shape_1_);}\n\t.googlepubsub1{opacity:7.000000e-02;}\n\t.googlepubsub2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "PubSub_128px",
    transform: "translate(297.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BASE_2_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1099.2635,
    y1: 2340.8027,
    x2: -1099.2635,
    y2: 2351.9829,
    gradientTransform: "matrix(35.6175 0 0 31.7029 39058.5938 -74286.0156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4387FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4683EA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_8_",
    className: "googlepubsub0",
    d: "M-207.2,261.3L-289,119.6c-6.4-11.1-6.4-24.7,0-35.8l81.8-141.7c6.4-11.1,18.2-17.9,31-17.9 h163.6c12.8,0,24.6,6.8,31,17.9l81.8,141.7c6.4,11.1,6.4,24.7,0,35.8L18.4,261.3c-6.4,11-18.2,17.9-31,17.9h-163.6 C-189,279.2-200.8,272.3-207.2,261.3L-207.2,261.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shadow_2_",
    transform: "translate(10.573913, 7.513043)",
    className: "googlepubsub1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_9_",
    points: "72.8,142.7 -26.4,43.5 -44.7,47.3 -90.2,1.8 -104.7,29 -112.6,60.5 -99.2,73.9 -124.9,79.1  -160.1,43.9 -184,66.9 -140,110.9 -186.6,148 -61.4,273.2 -0.4,272.6  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "art_2_",
    transform: "translate(10.017391, 6.956522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "googlepubsub2",
    cx: -37.4,
    cy: 56,
    rx: 16.6,
    ry: 16.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_1_",
    className: "googlepubsub2",
    cx: -171.5,
    cy: 56,
    r: 16.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2_",
    className: "googlepubsub2",
    cx: -104.4,
    cy: 172.1,
    r: 16.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path",
    transform: "translate(1.669565, 1.947826)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80.2,
    y: 73.4,
    transform: "matrix(0.5 -0.866 0.866 0.5 -133.3826 -6.8216)",
    className: "googlepubsub2",
    width: 15.3,
    height: 77.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -178.3,
    y: 104.5,
    transform: "matrix(0.866 -0.5 0.5 0.866 -74.7834 -54.7812)",
    className: "googlepubsub2",
    width: 77.4,
    height: 15.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -113.8,
    y: 15.3,
    className: "googlepubsub2",
    width: 15.3,
    height: 77.4
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3_",
    className: "googlepubsub2",
    cx: -104.4,
    cy: 94.7,
    r: 26.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_4_",
    className: "googlepubsub2",
    cx: -171.5,
    cy: 133.4,
    rx: 21.1,
    ry: 21.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_5_",
    className: "googlepubsub2",
    cx: -37.4,
    cy: 133.4,
    r: 21.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_6_",
    className: "googlepubsub2",
    cx: -104.4,
    cy: 17.3,
    r: 21.1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglepubsub);
export default __webpack_public_path__ + "static/media/googlepubsub.036491bb31269a368077da5d3cd330d2.svg";
export { ForwardRef as ReactComponent };